import store from '../store'
import gsap from 'gsap'

export default class Menu {
  constructor() {
    this.menuOpen = false
    this.subMenuOpen = false
    this.locked = false
    this.resetting = false
    this.currentScroll = 0
    this.activeIndex = -1

    this.progress = {
      scale: 0,
      translate: 0
    }

    store.isMobile && (this.height = document.querySelector('.app').getBoundingClientRect().height)

    this.bindMethods()
    this.getElems()
    this.addEvents()
    this.onPageChange({ href: window.location.href })
  }

  bindMethods() {
    this.toggle = this.toggle.bind(this)
    this.showSubmenu = this.showSubmenu.bind(this)
    this.closeSubmenus = this.closeSubmenus.bind(this)
    this.onSubmenuLeave = this.onSubmenuLeave.bind(this)
  }

  getElems() {
    this.submenu = {
      parent: [],
      children: []
    }

    this.header = document.querySelector('.header')
    this.menu = this.header.querySelector('.menu')
    this.toggler = this.header.querySelector('.header__toggler')
    this.$links = this.header.querySelectorAll('.menu__item--sub')
    this.wrapper = this.header.querySelectorAll('.menu__submenu-items')
    this.$submenus = this.header.querySelectorAll('.menu__submenu')
    this.$menuLinks = this.header.querySelectorAll('.menu__item')
    this.$close = this.header.querySelectorAll('.menu__submenu-close')
    this.progressBar = this.header.querySelector('.header__progress--bar')
    this.progressLight = this.header.querySelector('.header__progress--light')

    for (let i = 0; i < this.$links.length; i++) {
      this.submenu.parent.push({
        el: this.$links[i],
        wrapper: this.$submenus[i],
        itemsWrapper: this.wrapper[i]
      })
    }

    for (let i = 0; i < this.$submenus.length; i++) {
      this.$items = this.$submenus[i].querySelectorAll('.menu__submenu-item')
      this.$images = this.$submenus[i].querySelectorAll('.menu__submenu-image')

      for (let j = 0; j < this.$items.length; j++) {
        this.submenu.children.push({
          item: this.$items[j],
          image: this.$images[j]
        })
      }
    }
  }

  addEvents() {
    this.toggler && this.toggler.addEventListener('click', this.toggle)

    if (!store.isMobile) {
      for (let i = 0; i < this.wrapper.length; i++) this.wrapper[i].addEventListener('mouseleave', this.onSubmenuLeave)
    }

    for (let i = 0; i < this.$close.length; i++) this.$close[i].addEventListener('click', this.closeSubmenus)

    for (let i = 0; i < this.submenu.parent.length; i++) this.submenu.parent[i].el.addEventListener('click', this.showSubmenu)

    for (let i = 0; i < this.submenu.children.length; i++) this.submenu.children[i].item.addEventListener('mouseover', this.showImage.bind(this, i))
  }

  onNavigateEnd() {
    store.isMobile && (this.height = document.querySelector('.app').getBoundingClientRect().height)
  }

  onPageChange(location) {
    this.close()
    this.closeSubmenus()
    this.header.classList.remove('h')

    if (this.activeIndex > -1) this.$menuLinks[this.activeIndex].classList.remove('a')
    if (this.subActiveIndex > -1) {
      this.submenu.children[this.subActiveIndex].item.classList.remove('a')
      this.submenu.children[this.subActiveIndex].image.classList.remove('v')
    }

    this.activeIndex = -1
    this.subActiveIndex = -1

    for (let i = 0; i < this.$menuLinks.length; i++) {
      this.$menuLinks[i].href === location.href && (this.activeIndex = i)
    }

    for (let i = 0; i < this.submenu.children.length; i++) {
      this.submenu.children[i].item.classList.toggle('a', this.submenu.children[i].item.href === location.href)
      this.submenu.children[i].image.classList.toggle('v', this.submenu.children[i].item.href === location.href)

      if (this.submenu.children[i].item.href === location.href) {
        this.subActiveIndex = i
        for (let j = 0; j < this.submenu.parent.length; j++) {
          this.submenu.parent[j].el.classList.toggle('a', this.submenu.children[i].item.closest('.menu__submenu-items') === this.submenu.parent[j].itemsWrapper)
          this.submenu.parent[j].itemsWrapper.classList.toggle('has-a', this.submenu.children[i].item.closest('.menu__submenu-items') === this.submenu.parent[j].itemsWrapper)
        }
        break
      } else {
        for (let j = 0; j < this.submenu.parent.length; j++) {
          this.submenu.parent[j].el.classList.remove('a')
          this.submenu.parent[j].itemsWrapper.classList.remove('has-a')
        }
      }
    }

    if (this.activeIndex > -1) this.$menuLinks[this.activeIndex].classList.add('a')
  }

  showSubmenu(e) {
    const key = this.submenu.parent.find((v) => v.el === e.target)

    for (let i = 0; i < this.submenu.parent.length; i++) {
      this.subMenuOpen = this.submenu.parent[i].el === key.el && !this.submenu.parent[i].wrapper.classList.contains('active')
      this.submenu.parent[i].wrapper.classList.toggle('active', this.subMenuOpen)
    }
  }

  closeSubmenus() {
    for (let i = 0; i < this.submenu.parent.length; i++) this.submenu.parent[i].wrapper.classList.remove('active')
  }

  showImage(index) {
    const item = this.submenu.children[index].item

    for (let i = 0; i < this.submenu.children.length; i++) this.submenu.children[i].image.classList.toggle('v', this.submenu.children[i].item === item)
  }

  onSubmenuLeave() {
    for (let i = 0; i < this.submenu.children.length; i++) this.submenu.children[i].image.classList.toggle('v', this.subActiveIndex === i)
  }

  toggle() {
    if (this.isAnimating) return

    this.menu.classList.toggle('a')
    if (this.menuOpen) this.close()
    else this.open()
  }

  open() {
    this.menuOpen = true
    this.menu.classList.add('a')
    this.toggler.classList.add('a')
  }

  close() {
    this.menuOpen = false
    this.closeSubmenus()
    this.menu.classList.remove('a')
    this.toggler.classList.remove('a')
  }

  lock(hide = false) {
    this.locked = true
    this.header.classList.remove('h')
    hide && this.header.classList.add('hide')
  }

  unlock() {
    this.locked = false
    this.header.classList.remove('hide')
  }

  reset() {
    this.resetting = true

    gsap.fromTo(this.progressBar, { scaleX: this.progress.scale }, {
      scaleX: 0,
      duration: 1,
      ease: 'power3.out'
    })

    gsap.fromTo(this.progressLight, { x: this.progress.translate }, {
      x: 0,
      duration: 1,
      ease: 'power3.out',
      onComplete: () => {
        this.progress = {
          scale: 0,
          translate: 0
        }

        this.resetting = false
      }
    })
  }

  map(x, a, b, c, d) {
    return (x - a) * (d - c) / (b - a) + c
  }

  resize() {
    store.isMobile && (this.height = document.querySelector('.app').getBoundingClientRect().height)
  }

  scroll() {
    const last = this.currentScroll

    const instance = store?.smoothScroll?.scroll?.instance
    if (!instance) {
      console.warn('Instance de smoothScroll introuvable')
      return
    }

    const { scroll, limit, delta } = instance

    if (!scroll || !scroll.y) {
      console.warn('scroll ou scroll.y est indéfini')
      return
    }

    if (!this.resetting) {
      if (store.isMobile) {
        this.progress.scale = scroll.y / (this.height - store.w.wh)
        this.progress.translate = store.w.ww * (scroll.y / (this.height - store.w.wh))

        this.progressBar.style.transform = `scaleX(${this.progress.scale})`
        this.progressLight.style.transform = `translate(${this.progress.translate}px, -42%)`
      } else {
        const d = this.map(Math.abs((delta.y - scroll.y) * 0.1), 0, 100, 1, 2)

        this.progress.scale = scroll.y / limit.y
        this.progress.translate = store.w.ww * (scroll.y / limit.y)

        this.progressLight.style.filter = `brightness(${d})`
        this.progressLight.style.transform = `translate(${this.progress.translate}px, -42%)`
        this.progressBar.style.transform = `scaleX(${this.progress.scale})`
      }
    }

    this.currentScroll = scroll.y
    this.header.classList.toggle('h', last < this.currentScroll && this.currentScroll > store.w.wh && !this.subMenuOpen && !this.menuOpen && !this.locked && !this.resetting)
  }
}
